import React from 'react';
import { Chip } from '@mui/material';

const StatusIndicator = ({ variant = "success", label, showDot = true }) => {
   const config = {
      success: { bgColor: '#DCFFF1', color: '#22A06B' },
      error: { bgColor: '#FFE1C2', color: '#DC6600' },
      info: {
         bgColor: '#FFF7D6', color: '#B38600'
      }
   };

   const badgeConfig = config[variant] || config.success;

   return (
      <Chip
         label={
            <span style={{ display: 'flex', alignItems: 'center' }}>
               {showDot && (
                  <span
                     style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        backgroundColor: badgeConfig.color,
                        marginRight: '8px',
                     }}
                  />
               )}
               {label}
            </span>
         }
         sx={{
            backgroundColor: badgeConfig.bgColor,
            color: badgeConfig.color,
            fontWeight: 600,
            fontSize: '12px',
            borderRadius: "4px",
            padding: '4px 8px',
            height: '32px',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
         }}
      />
   );
};

export default StatusIndicator;
